export const logErr = (...params: any[]) => {
  const [label, ...configs] = params;
};
export const log = (...params: any[]) => {
  console.log(...params);
};
export const logConfig = (...params: any[]) => {
  const [label, ...configs] = params;
};
